import authenticationReducer from 'ducks/authentication';
import automationConditionsReducer from 'ducks/automationConditions';
import bootstrapReducer from 'ducks/bootstrap';
import bucketsReducer from 'ducks/buckets';
import calibrationsReducer from 'ducks/calibrations';
import deploysReducer from 'ducks/deploys';
import deviceLogsReducer from 'ducks/deviceLogs';
import devicesReducer from 'ducks/devices';
import deviceVerificationReadingsReducer from 'ducks/deviceVerificationReadings';
import deviceVerificationsReducer from 'ducks/deviceVerifications';
import drawerViewReducer from 'ducks/drawerView';
import equipmentReducer from 'ducks/equipment';
import equipmentAttachmentsReducer from 'ducks/equipmentAttachments';
import equipmentCategoriesReducer from 'ducks/equipmentCategories';
import formInitializerReducer from 'ducks/formInitializer';
import indicatorsReducer from 'ducks/indicators';
import installationPicturesReducer from 'ducks/installationPictures';
import installationZonesReducer from 'ducks/installationZones';
import loadSiteReducer from 'ducks/loadSite';
import logReducer from 'ducks/logs';
import measurementsReducer from 'ducks/measurements';
import protocolsReducer from 'ducks/protocols';
import readingsReducer from 'ducks/readings';
import sitesReducer from 'ducks/sites';
import templatesReducer from 'ducks/templates';
import uiReducer from 'ducks/ui';
import userFeedback from 'ducks/userFeedback';
import usersReducer from 'ducks/users';
import wiseBoxesReducer from 'ducks/wise_boxes';
import wiseBoxDevicesReducer from 'ducks/wiseBoxDevices';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

const appReducer = combineReducers({
    auth: authenticationReducer,
    automationConditions: automationConditionsReducer,
    bootstrap: bootstrapReducer,
    buckets: bucketsReducer,
    sites: sitesReducer,
    calibrations: calibrationsReducer,
    deploys: deploysReducer,
    deviceLogs: deviceLogsReducer,
    deviceVerificationReadings: deviceVerificationReadingsReducer,
    deviceVerifications: deviceVerificationsReducer,
    devices: devicesReducer,
    drawerView: drawerViewReducer,
    equipmentAttachments: equipmentAttachmentsReducer,
    equipmentCategories: equipmentCategoriesReducer,
    equipments: equipmentReducer,
    form: formReducer,
    formInitializers: formInitializerReducer,
    indicators: indicatorsReducer,
    installationPictures: installationPicturesReducer,
    installationZones: installationZonesReducer,
    loadedSites: loadSiteReducer,
    logs: logReducer,
    measurements: measurementsReducer,
    protocols: protocolsReducer,
    readings: readingsReducer,
    templates: templatesReducer,
    ui: uiReducer,
    userFeedback: userFeedback,
    users: usersReducer,
    wiseBoxDevices: wiseBoxDevicesReducer,
    wiseBoxes: wiseBoxesReducer
});

// https://stackoverflow.com/a/35641992
export default (state, action) => {
    if (action.type === 'LOGOUT') {
        state = undefined;
    }

    return appReducer(state, action);
};
